import { useCallback, useState } from 'react'

import { type Enum } from '@webapp/infrastructure/types/Enum'

export const SupplierWidgetStatuses = {
  LOADING: 'loading',
  READY: 'ready',
  FAILED: 'failed',
} as const

export type SupplierWidgetStatusEnum = Enum<typeof SupplierWidgetStatuses>

export interface UseSupplierWidgetStatusResult {
  status: SupplierWidgetStatusEnum
  markReady: () => void
  markFailed: () => void
}

const settleIfLoading =
  (next: SupplierWidgetStatusEnum) => (current: SupplierWidgetStatusEnum) =>
    current === SupplierWidgetStatuses.LOADING ? next : current

export const useSupplierWidgetStatus = (): UseSupplierWidgetStatusResult => {
  const [status, setStatus] = useState<SupplierWidgetStatusEnum>(
    SupplierWidgetStatuses.LOADING
  )

  const markReady = useCallback(
    () => setStatus(settleIfLoading(SupplierWidgetStatuses.READY)),
    []
  )
  const markFailed = useCallback(
    () => setStatus(SupplierWidgetStatuses.FAILED),
    []
  )

  return { status, markReady, markFailed }
}
